module.exports = __webpack_public_path__ + "img/167-242468.png";